import lrCreateuser from './_src/lrCreateuser2.vue'

lrCreateuser.install = function(Vue) {
  Vue.component(lrCreateuser.name, lrCreateuser)
}

export default lrCreateuser